<template>
  <div class="hero">
    <div class="container container-small">
      <div class="left">
        <router-link class="button-back" :to="{ name: 'virtual'}">
          <svg>
            <use xlink:href="#scrollDownSvg"></use>
          </svg>
        </router-link>

        <TextSection
          v-for="(item, index) in text" :key="index"
          :header="item.header"
          :description="item.description"
          class="header"
          :underline="true"
          :uppercase="false"
          :cutLength="570"
          :cutLengthTextBig ="300"
        />
        <form action="#"
              method="post"
              @submit.prevent="submitNewsletterForm()"
              novalidate="true" >
          <ul class="list-clean"
              :class="{ 'has-error' : displayNewsletterErrors }">
            <li v-if="(newsletterErrors && !isNewsletterSignin) || displayNewsletterErrors">
              <small>{{ displayNewsletterErrors }}</small>
            </li>
            <li v-if="isNewsletterSignin">
              <p>{{ footerData.newsletter.thanks }}</p>
            </li>
            <li class="input-wrapper" v-if="!isNewsletterSignin">
              <input type="email"
                     class="text-m"
                     name="notification-email"
                     id="notification-email"
                     v-model="notificationFormData['notification-email']"
                     @focus="clearNewsletterErrors"
                     @blur="checkForm"
                     :placeholder="newsletter.placeholder" />
              <button type="submit"
                class="text-s">
                {{ newsletter.button }}
              </button>
            </li>
            <li v-if="!isNewsletterSignin">
              <label class="checkbox-item">
                <input type="checkbox"
                       name="notification-accepted-privacy"
                       id="notification-accepted-privacy"
                       value="true"
                       v-model="notificationFormData['notification-accepted-privacy']" />
                <span class="checkbox-item-label text-xs">
                  {{ newsletter.acceptTerms }}
                  <router-link :to="{ name: 'privacy'}">
                    {{ newsletter.acceptTermsLink }}
                  </router-link>
                </span>
              </label>
            </li>
          </ul>
        </form>
      </div>
      <SwipeHandler @swipeLeft="swipeLeft" @swipeRight="swipeRight" class="slider image-overflow">
        <div class="slide-wrapper">
          <figure class="slide" v-for="(item, index) in images" :key="'item' + index" :class="{
              prev: index == (activeItem - 1 + images.length) % images.length,
              active: index == activeItem,
              next: index == (activeItem + 1) % images.length
            }">
            <img :src="item" :alt="museumData.title">
          </figure>
        </div>
      </SwipeHandler>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import TextSection from '@/components/TextSection.vue'
import SwipeHandler from '@/components/SwipeHandler.vue'

export default {
  name: 'contactSection',
  props: ['images', 'text', 'newsletter'],
  components: {
    TextSection,
    SwipeHandler
  },
  data: function () {
    return {
      activeItem: 0,
      loop: true,
      loopTimeout: null,
      notificationFormData: {
        'notification-email': '',
        'notification-accepted-privacy': false
      },
      displayNewsletterErrors: null
    }
  },
  methods: {
    ...mapActions([
      'sendNewsletterForm',
      'clearNewsletterErrors'
    ]),
    swipeRight () {
      this.showPrev()
    },
    swipeLeft () {
      this.showNext()
    },
    showNext () {
      this.activeItem = this.activeItem + 1 < this.images.length
        ? Math.min(this.activeItem + 1, this.images.length - 1)
        : 0
      this.loop = false
      window.clearTimeout(this.loopTimeout)
    },
    loopNext () {
      if (this.loop) {
        this.activeItem = this.activeItem + 1 < this.images.length
          ? Math.min(this.activeItem + 1, this.images.length - 1)
          : 0
        this.loopTimeout = window.setTimeout(() => {
          this.loopNext()
        }, 4000)
      }
    },
    showPrev () {
      this.activeItem = this.activeItem - 1 >= 0
        ? Math.max(this.activeItem - 1, 0)
        : this.images.length - 1
      this.loop = false
      window.clearTimeout(this.loopTimeout)
    },
    validateEmail (value) {
      const emailRegex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
      return emailRegex.test(value)
    },
    checkForm () {
      this.displayNewsletterErrors = null
      if (!this.validateEmail(this.getNewsletterEmail)) {
        this.displayNewsletterErrors = this.errorData.incorrectEmail
      } else {
        if (!this.getNewsletterAccept) {
          this.displayNewsletterErrors = this.errorData.noApproval
        }
      }
    },
    getNewsletterErrors () {
      let errorMsg = ''
      switch (this.newsletterErrors) {
        case 404:
          errorMsg = this.errorData.networkError
          break
        default:
          errorMsg = this.newsletterErrors
          break
      }
      return errorMsg + ' ' + this.errorData.tryAgain
    },
    submitNewsletterForm () {
      this.checkForm()
      if (this.displayNewsletterErrors || this.isNewsletterSignin) { return false }
      this.sendNewsletterForm(this.getNewsletterEmail)
    }
  },
  computed: {
    ...mapGetters([
      'isNewsletterSignin',
      'newsletterErrors',
      'footerData',
      'museumData',
      'errorData'
    ]),
    getNewsletterEmail () {
      return this.notificationFormData['notification-email']
    },
    getNewsletterAccept () {
      return this.notificationFormData['notification-accepted-privacy']
    }
  },
  watch: {
    newsletterErrors (oldVal, newVal) {
      if (oldVal !== newVal) {
        this.displayNewsletterErrors = this.getNewsletterErrors()
      }
    },
    getNewsletterEmail (oldVal, newVal) {
      if (oldVal !== newVal) {
        this.displayNewsletterErrors = (this.validateEmail(newVal) ? this.errorData.incorrectEmail : null)
      }
    },
    getNewsletterAccept (oldVal, newVal) {
      if (oldVal !== newVal) {
        this.displayNewsletterErrors = (newVal ? this.errorData.noApproval : null)
      }
    }
  },
  mounted () {
    this.clearNewsletterErrors()
    setTimeout(this.loopNext, 4000)
  }
}
</script>

<style scoped lang="scss">
  .hero {
    .container {
      display: flex;
      padding: 45px 0;
      @include mobile {
        flex-direction: column;
        padding-bottom: 0;
      }
    }
    .container-small {
      @include desktop {
        max-width: calc(88% - 100px);
      }
      @include desktop-small {
        max-width: 88%;
      }
    }
  }
  .hero-animation {
    width: 50%;
    display: flex;
    align-items: center;
    img {
      display: block;
      max-width: 100%;
    }
    @include mobile {
      width: 100%;
    }
  }
  .left {
    width: 50%;
    @include mobile {
      width: 100%;
    }
  }
  .button-back {
    color: $text-dark;
    display: block;
    text-decoration: none;
    border: none;
    box-shadow: none;
    background-color: transparent;
    width: 60px;
    height: 40px;
    text-align: left;
    padding: 0;
    margin: 0 0 $gap-lg 0;
    svg {
      max-height: 26px;
      position: relative;
      transition: $transition;
      transform: rotate(90deg);
      width: 26px;
    }
    &:focus {
      outline: none;
    }
    &:hover,&:focus {
      svg {
        transform: rotate(90deg) translate(0, 8px);
      }
    }
  }
  form {
    margin: -30px 0 0 0;
    position: relative;
  }
  .input-wrapper {
    color: $text-dark;
    padding: 10px 0;
    border-bottom: 2px solid $text-dark;
    max-width: 350px;
    @include clearfix();
    font-weight: 500;
    margin: 0;

  input {
    margin: 0;
    padding: 0;
    background-color: transparent;
    border: none;
    color: $text-dark;
    font-weight: 500;
    width: calc(100% - 120px);
    &:focus {
      outline: none;
    }
    &::placeholder {
      color: $text-dark;
      font-size: 14px;
      font-weight: 500;
    }
  }
  button {
    background-color: transparent;
    color: $text-dark;
    border: none;
    box-shadow: none;
    text-align: right;
    text-transform: uppercase;
    float: right;
    cursor: pointer;
    width: 100px;
    font-weight: 500;

    &:hover,&:focus {
      color: $text-accent;
      outline: none;
    }
  }
  .has-error & {
    border-color: $color-error;

    input {
      color: $color-error;
    }
  }
  @include mobile {
    max-width: 100%;
    width: 100%;
  }
}
.list-clean {
  margin-bottom: 5em;

  li {
    margin-bottom: $gap-xs;
  }
}
.image-overflow {
    position: absolute;
    bottom: -40px;
    margin-top: -80px;
    right: 0;
    height: 100%;
    width: 50%;
    pointer-events: none;
    @include desktop-small {
      right: 0;
    }
    @include tablet {
      position: relative;
      bottom: -30px;
      max-width: 100%;
      height: 600px;
      width: 100%;
    }
    @include mobile {
      height: 90vw;
    }
  }
  .slide {
    display: none;
    transition: $transitionSlider;
    position: absolute;

    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 1;
    text-align: left;
    height: 100%;
    align-items: flex-end;
    padding: 0;
    margin: 0;
    img {
      max-width: 90%;
      max-height: 90%;
      height: auto;
      width: 600px;
    }
    p {
      margin: 0;
      font-weight: 500;
    }
    &.prev {
      display: flex;
      transform: translateX(-100vw);
      opacity: 0;
    }
    &.next {
      display: flex;
      transform: translateX(100vw);
      opacity: 0;
    }
    &.active {
      display: flex;
      transform: translateX(0);
      opacity: 1;
    }
    @include tablet {
      justify-content: center;
    }
  }
  .slide-wrapper {
    position: relative;
    min-width: 356px;
    width: 100%;
    overflow: hidden;
    height: 100%;
    text-align: left;
    margin-right: 80px;
    @include tablet {
      width: 100%;
      max-width: 100%;
      min-width: 100%;
      margin-right: 0;
    }
  }
</style>
